import {
  BffTrimData,
  ChargeTimeTrimModel,
  CostTrimModel,
  RangeTrimModel,
} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';
import {SelectOption, SelectOptionGroup} from '../types';
import {formatTrimSelectId} from './format-trim-select-id';
import {isValidEngine} from './is-valid-engine';
import {formatModelSelectId} from './format-model-select-id';
import {Logger} from '@feature-hub/core';

export const getModelEngineOptions = (
  trim: BffTrimData<ChargeTimeTrimModel | CostTrimModel | RangeTrimModel>,
  logger?: Logger
): SelectOption[] => {
  const engineOptions: SelectOption[] = [];

  for (const model of trim.modelVariants) {
    if (isValidEngine(model.engine)) {
      engineOptions.push({
        value: formatModelSelectId(model),
        label: model.trimId
          ? model.trimId.concat(` ${model.engine}`)
          : model.engine,
      });
    } else {
      logger?.warn(`No valid engine found for the model with id ${model.id}`);
    }
  }

  return engineOptions;
};

export const getTrimSelectOptionGroups = (
  trims: BffTrimData<ChargeTimeTrimModel | CostTrimModel | RangeTrimModel>[],
  groupingMode: 'carline' | 'salesgroup',
  includeEngineToOption: boolean,
  logger?: Logger
): SelectOptionGroup[] => {
  const groups: SelectOptionGroup[] = [];

  trims.forEach((trim) => {
    const trimOptions: SelectOption[] = [];

    if (includeEngineToOption) {
      const engineOptions = getModelEngineOptions(trim, logger);

      engineOptions.forEach((engineOption) => {
        trimOptions.push({
          value: formatTrimSelectId(trim).concat(`,${engineOption.value}`),
          // The "trim id" is also the visual label
          label: trim.trimId.concat(` ${engineOption.label}`),
        });
      });
    } else {
      trimOptions.push({
        value: formatTrimSelectId(trim),
        // The "trim id" is also the visual label
        label: trim.trimId,
      });
    }

    const group = groups.find((g) =>
      groupingMode === 'salesgroup'
        ? g.groupId === trim.salesgroupId
        : g.groupId === trim.carlineId
    );

    if (!group) {
      groups.push({
        groupId:
          groupingMode === 'salesgroup' ? trim.salesgroupId : trim.carlineId,
        label:
          groupingMode === 'salesgroup'
            ? trim.assets.texts.salesgroupName
            : trim.assets.texts.carlineName,
        options: trimOptions,
      });
    } else {
      trimOptions.forEach((option) => {
        group.options.push(option);
      });
    }
  });

  return groups;
};
